import React from "react";
import { COLOR_VENTAS } from "./constants";
import { formatCurrency, formatNumber } from "./utils";

export default function TablaTopClientes(props) {
    const moneda = props.moneda || "PEN";
    const clientes = props.clientes || [];

    return (
        <div className="resumen-tabla-contenedor">
            <table className="resumen-tabla">
                <thead>
                    <tr>
                        <th></th>
                        <th>Cliente</th>
                        <th className="resumen-tabla-derecha">Ventas</th>
                        <th></th>
                        <th className="resumen-tabla-derecha">% del Total</th>
                        <th className="resumen-tabla-derecha">Cpe</th>
                        <th className="resumen-tabla-derecha">Cpe Promedio</th>
                    </tr>
                </thead>
                <tbody>
                    {clientes.length === 0 ? (
                        // Sin informacion se muestra una fila en 0 en vez de
                        // dejar la tabla vacia.
                        <tr>
                            <td>-</td>
                            <td className="resumen-tabla-vacio">Sin información</td>
                            <td className="resumen-tabla-derecha resumen-tabla-fuerte">{formatCurrency(0, moneda)}</td>
                            <td><div className="resumen-barra" /></td>
                            <td className="resumen-tabla-derecha">0.0%</td>
                            <td className="resumen-tabla-derecha resumen-tabla-fuerte">0</td>
                            <td className="resumen-tabla-derecha">{formatCurrency(0, moneda)}</td>
                        </tr>
                    ) : clientes.map((item, indice) => (
                        <tr key={item.nombre}>
                            <td>{indice + 1}</td>
                            <td className="resumen-tabla-cliente" title={item.nombre}>{item.nombre}</td>
                            <td className="resumen-tabla-derecha resumen-tabla-fuerte">{formatCurrency(item.ventas, moneda)}</td>
                            <td>
                                <div className="resumen-barra">
                                    <div className="resumen-barra-avance" style={{ width: `${item.avance}%`, backgroundColor: COLOR_VENTAS }} />
                                </div>
                            </td>
                            <td className="resumen-tabla-derecha">{formatNumber(item.porcentaje)}%</td>
                            <td className="resumen-tabla-derecha resumen-tabla-fuerte">{formatNumber(item.cpe, 0)}</td>
                            <td className="resumen-tabla-derecha">{formatCurrency(item.cpePromedio, moneda)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
